<template>
  <b-card style="padding:40px;">
    <h5><b>UPDATE USER</b></h5>
    <hr />

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Name <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.name"
            :id="`input-role`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.name">
            <span class="danger-new">{{ this.error.name }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Date Of Birth</label>
          <b-form-input
            v-model="form.dob"
            :id="`input-role`"
            :type="`date`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Company Name</label>
          <b-form-input
            v-model="form.comp_name"
            :id="`input-role`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Role <span class="danger-new">*</span></label
          >
          <b-form-select
            v-model="form.role"
            :options="role"
            @change="changeRole"
          ></b-form-select>
          <p v-if="error.role">
            <span class="danger-new">{{ this.error.role }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group
          v-if="form.role == '3' || form.role == '4' || form.role == '5'"
        >
          <label v-if="form.role == '3'" :for="`input-role`"
            >Stokist Name</label
          >
          <label v-if="form.role == '4'" :for="`input-role`"
            >Home Dealer Name</label
          >
          <multiselect
            v-model="form.upline"
            :options="upline"
            placeholder="Please select"
            label="name"
            track-by="name"
          ></multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="12">
        <b-form-group>
          <label :for="`input-role`"
            >Address <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.add1"
            :id="`input-role`"
            :type="`text`"
            maxlength="100"
            class="input-new"
          ></b-form-input>
          <p v-if="error.add1">
            <span class="danger-new">{{ this.error.add1 }}</span>
          </p>
          <br />
          <b-form-input
            v-model="form.add2"
            :id="`input-role`"
            :type="`text`"
            maxlength="100"
            class="input-new"
          ></b-form-input
          ><br />
          <b-form-input
            v-model="form.add3"
            :id="`input-role`"
            :type="`text`"
            maxlength="100"
            class="input-new"
          ></b-form-input
          ><br />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >State <span class="danger-new">*</span></label
          >
          <b-form-select v-model="form.state" :options="state"></b-form-select>
          <p v-if="error.state">
            <span class="danger-new">{{ this.error.state }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >City <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.city"
            :id="`input-role`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.city">
            <span class="danger-new">{{ this.error.city }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Postcode <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.postcode"
            :id="`input-role`"
            :type="`number`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.postcode">
            <span class="danger-new">{{ this.error.postcode }}</span>
          </p>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`"
            >Email <span class="danger-new">*</span></label
          >
          <b-form-input
            v-model="form.email"
            :id="`input-role`"
            :type="`email`"
            class="input-new"
          ></b-form-input>
          <p v-if="error.email">
            <span class="danger-new">{{ this.error.email }}</span>
          </p>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Phone Number</label>
          <b-form-input
            v-model="form.phone_no"
            :id="`input-role`"
            :type="`number`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-accno`">Account No.</label>
          <b-form-input
            v-model="form.accno"
            :id="`input-accno`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-credit`">Credit Terms</label>
          <b-form-input
            v-model="form.credit_terms"
            :id="`input-credit`"
            :type="`text`"
            class="input-new"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickUpdate"
          >UPDATE</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  data() {
    return {
      chiller: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
      ],
      form: {
        name: "",
        dob: "",
        comp_name: "",
        add1: "",
        add2: "",
        add3: "",
        city: "",
        postcode: "",
        email: "",
        phone_no: "",
        state: "",
        role: "",
        chiller: "",
        upline: "",
        credit_terms: "",
        accno: ""
      },
      state: [],
      role: [],
      upline: [],
      error: {
        name: "",
        role: "",
        add1: "",
        state: "",
        city: "",
        postcode: "",
        email: ""
      }
    };
  },
  created() {
    this.showUser();
    this.getReftable();
    // this.getUpline();
  },
  methods: {
    onClickBack() {
      let path = `/user_management?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}&state=${this.$route.query.state}&access_lvl=${this.$route.query.access_lvl}&email=${this.$route.query.email}`;

      this.$router.push({
        path: path
      });
    },
    getUpline() {
      this.upline = [];
      this.$store.dispatch("getUpline").then(res => {
        this.upline = [];
        res.data.data.forEach(element => {
          this.upline.push({
            id: element.user_id,
            name: element.name
          });
        });
      });
    },
    getHD() {
      this.upline = [];
      this.$store.dispatch("getHomeDealer").then(res => {
        this.upline = [];
        res.data.data.forEach(element => {
          this.upline.push({
            id: element.user_id,
            name: element.name
          });
        });
      });
    },
    getReftable() {
      this.$store.dispatch("getReftable", "state").then(res => {
        res.data.data.state.forEach(element => {
          this.state.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
      this.$store.dispatch("getReftable", "role").then(res => {
        res.data.data.role.forEach(element => {
          this.role.push({
            value: element.ref_code,
            text: element.desc
          });
        });
      });
    },
    showUser() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$route.query.id
        })
        .then(res => {
          if (res.data.response.code === 100) {
            let upline = "";
            if (res.data.data.downline !== null) {
              upline = {
                id: res.data.data.downline.upline_id,
                name: res.data.data.downline.userdetails.name
              };
            }
            this.form.id = this.$route.query.id;
            this.form.name = res.data.data.name;
            this.form.dob = res.data.data.dob;
            this.form.comp_name = res.data.data.company;
            this.form.role = res.data.data.role_details.ref_code;
            this.form.chiller = res.data.data.chiller == true ? "1" : "0";
            this.form.add1 = res.data.data.add1;
            this.form.add2 = res.data.data.add2;
            this.form.add3 = res.data.data.add3;
            this.form.state = res.data.data.state_details.ref_code;
            this.form.city = res.data.data.city;
            this.form.postcode = res.data.data.postcode;
            this.form.email = res.data.data.email;
            this.form.phone_no = res.data.data.phone_no;
            this.form.upline = upline;
            this.form.credit_terms = res.data.data.credit_terms;
            this.form.accno = res.data.data.accno;

            if (res.data.data.role_details.ref_code == 3) {
              this.getUpline();
            } else if (res.data.data.role_details.ref_code == 4) {
              this.getHD();
            }
          }
        });
    },
    onClickUpdate() {
      this.checkForm();
      const form = {
        name: this.form.name,
        dob: this.form.dob,
        company: this.form.comp_name,
        add1: this.form.add1,
        add2: this.form.add2,
        add3: this.form.add3,
        city: this.form.city,
        postcode: this.form.postcode,
        email: this.form.email,
        phone_no: this.form.phone_no,
        access_lvl: this.form.role,
        state: this.form.state,
        user_id: this.form.id,
        upline_id: this.form.upline.id,
        chiller: this.form.chiller,
        accno: this.form.accno,
        credit_terms: this.form.credit_terms
      };
      this.$store.dispatch("createUser", form).then(res => {
        if (res.data.response.code === 1) {
          let path = `/user_management?filter=${this.$route.query.filter}&page=${this.$route.query.page}&name=${this.$route.query.name}&state=${this.$route.query.state}&access_lvl=${this.$route.query.access_lvl}&email=${this.$route.query.email}`;

          this.$router.push({
            path: path
          });
        }
      });
    },
    changeRole() {
      if (this.form.role == 3) {
        this.getUpline();
      } else if (this.form.role == 4) {
        this.getHD();
      }
    },
    checkForm: function(e) {
      if (
        this.form.name &&
        this.form.role &&
        this.form.add1 &&
        this.form.state &&
        this.form.city &&
        this.form.postcode &&
        this.form.email
      )
        return true;
      this.error.name = "";
      this.error.role = "";
      this.error.add1 = "";
      this.error.state = "";
      this.error.city = "";
      this.error.postcode = "";
      this.error.email = "";

      if (!this.form.name) this.error.name = "Name required.";
      if (!this.form.role) this.error.role = "Role required.";
      if (!this.form.add1) this.error.add1 = "Address required.";
      if (!this.form.state) this.error.state = "State required.";
      if (!this.form.city) this.error.city = "City required.";
      if (!this.form.postcode) this.error.postcode = "Postcode required.";
      if (!this.form.email) this.error.email = "Email required.";
      e.preventDefault();
    }
  }
};
</script>

<style lang="css" scoped></style>
